export const EpicKeyRing_EpicPrd = 'epic-prd';
export const EpicKeyRing_EpicNonprd = 'epic-nonprd';
export const EpicKeyRing_FhirEpic = 'fhir-epic';
export const EpicKeyRings = [EpicKeyRing_EpicPrd, EpicKeyRing_EpicNonprd, EpicKeyRing_FhirEpic];
//# sourceMappingURL=types.js.map